/**
 * 通用属性
 */

// 首页业务模块栅格布局
export const homeModuleGridLayout = {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 6 },
    lg: { span: 4 },
    xxl: { span: 3 },
};

// 抽屉宽
export const drawerWidth = 800;

// 抽屉中表单控件布局
export const drawerFormItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
};

// 抽屉中只读信息，用表单布局更好处理，同上
export const readonlyFormItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
};

// 页面表单布局（如课新增/编辑的页面级表单）
export const pageFormItemLayout = {
    labelCol: {
        sm: { span: 5 },
        // md: { span: 5 },
        lg: { span: 3 },
        xl: { span: 4 },
        xxl: { span: 6 },
    },
    wrapperCol: {
        sm: { span: 19 },
        // md: { span: 19 },
        lg: { span: 20 },
        xl: { span: 16 },
        xxl: { span: 14 },
    },
};

// 全宽页面表单布局
export const fullWidthPageFormItemLayout = {
    className: 'full-width-page-form',
    labelCol: {
        sm: { span: 24 },
        md: { span: 4 },
        lg: { span: 4 },
        xl: { span: 4 },
        xxl: { span: 6 },
    },
    wrapperCol: {
        sm: { span: 24 },
        md: { span: 20 },
        lg: { span: 20 },
        xl: { span: 18 },
        xxl: { span: 14 },
    },
};

// 页面表单布局（如新增/编辑的页面级表单），不带标签
export const pageFormItemWithoutLabelGridLayout = {
    wrapperCol: {
        sm: { offset: 5, span: 19 },
        // md: { offset:5, span: 19 },
        lg: { offset: 3, span: 20 },
        xl: { offset: 4, span: 16 },
        xxl: { offset: 6, span: 12 },
    },
};

// 筛选窗体栅格布局
export const filterFormGridLayout = {
    sm: { span: 24 },
    md: { span: 12 },
    xl: { span: 8 },
    xxl: { span: 6 },
};

// 筛选窗体表单控件布局
export const filterFormItemLayout = {
    labelCol: {
        sm: { span: 24 },
        md: { span: 8 },
    },

    wrapperCol: {
        sm: { span: 24 },
        md: { span: 16 },
    },
};

export const TABLE_PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100, 200, 500];

// 完整分页属性配置（antd 6：pagination.placement 替代已废弃的 pagination.position）
export const fullPagerConfig = {
    placement: 'bottom',
    showSizeChanger: true,
    hideOnSinglePage: false,
    showQuickJumper: true,
    pageSize: 10,
    pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
};

export const expertFormItemLayout = {
    labelCol: {
        sm: { span: 5 },
        md: { span: 5 },
        lg: { span: 5 },
        xl: { span: 4 },
        xxl: { span: 4 },
    },
    wrapperCol: {
        sm: { span: 19 },
        md: { span: 19 },
        lg: { span: 19 },
        xl: { span: 20 },
        xxl: { span: 20 },
    },
};

// 抽屉中表单控件布局 - 网站模块抽屉
export const drawerFormItemSiteLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
};

export const SelectionFormItemLayout = {
    labelCol: {
        sm: { span: 6 },
    },
    wrapperCol: {
        sm: { span: 17, offset: 1 },
    },
};

export const SelectionFormListItemLayout = {
    labelCol: {
        sm: { span: 6 },
    },
    wrapperCol: {
        sm: { span: 17, offset: 7 },
    },
};

/** 筛选面板表单项：与 Row gutter 配合时去掉默认下边距，避免行距翻倍 */
export const filterFormItemStyle = { marginBottom: 0 };

/**
 * 筛选行末尾「检索 / 重置」列在各断点下的 span / offset，使按钮组贴该行网格尾部。
 * span 与 {@link filterFormGridLayout} 保持一致，避免筛选项与按钮列错位。
 * @param {number} visibleFieldCount 当前可见筛选项个数（不含按钮列）
 */
export function computeButtonColLayout(visibleFieldCount) {
    const layout = {};
    for (const [key, { span }] of Object.entries(filterFormGridLayout)) {
        const cols = 24 / span;
        const emptyCols = (cols - 1 - (visibleFieldCount % cols) + cols) % cols;
        layout[key] = { span, offset: emptyCols * span };
    }
    return layout;
}
